import styled from "styled-components"

const CustomArrows = styled.button`
  border: none;
  background: black;
  border-radius: 50%;
  font-weight: bold;
  &:hover {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  &:focus {
    border: 2px ${(props) => props.theme.a_color_gradients.a_dark} solid;
  }
`

export { CustomArrows }
